export const commentConfig = {
  heading: 'Scenario Comments',
  message: '',
  callback: 'clickedViewCommentConfig',
};
